'use client';

import { GallerySummary } from '@/components/gallery/GallerySummary';
import { useLocationImageOrPlaceholderCollection } from '@/hooks/useLocationImageOrPlaceholderCollection';
import { ImageDto } from '@/lib/image.dto';

type LocationGalleryProps = {
  locationImages: ImageDto[];
  matterportUrl: string | null;
};

export default function LocationGallery({
  locationImages,
  matterportUrl,
}: LocationGalleryProps) {
  const images = useLocationImageOrPlaceholderCollection(locationImages);

  return (
    <GallerySummary
      className="w-full lg:h-[484px] md:h-[322px]"
      images={images}
      primaryImgSizes="(min-width: 1500px) 952px, (min-width: 1180px) calc(86.67vw - 331px), (min-width: 960px) calc(16vw + 486px), (min-width: 500px) calc(100vw - 80px), calc(100vw - 40px)"
      otherImgSizes="(min-width: 1160px) 388px, calc(93.33vw - 676px)"
      matterportUrl={matterportUrl}
      showMatterportThumbnail
    />
  );
}
